import { render, staticRenderFns } from "./YoutubeFrame.vue?vue&type=template&id=aac2ebaa&scoped=true"
import script from "./YoutubeFrame.vue?vue&type=script&lang=js"
export * from "./YoutubeFrame.vue?vue&type=script&lang=js"
import style0 from "./YoutubeFrame.vue?vue&type=style&index=0&id=aac2ebaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac2ebaa",
  null
  
)

export default component.exports